import type { WebsiteHeaderPhotoSchema_PageWidth } from '@shared/types/WebsiteHeaderSettings.types';

export const PAGE_WIDTH_DEFAULT: WebsiteHeaderPhotoSchema_PageWidth = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',
  presentationLayout: 'pageWidth',
  photos: [],
};
